<template>
  <div class="message-toast-main">
    <div @click="$emit('hide')" class="message-toast-overlay" />
    <div id="toaster" data-testid="toaster" :class="`message-toast ${type}`">
      <div class="message-toast-header">
        <a @click="$emit('hide')" class="message-toast-close">
            <i class="icon icon-close"></i>
        </a>

        <span class="message-toast--ttl">
          {{ type === 'success' ? $t('Success') : $t('Error') }}
        </span>

        <span class="message-toast--text">
          {{ message | translate }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Toast',

    props: {
      type: {
        type: String,
        default: ''
      },

      message: {
        type: String,
        default: ''
      },

      cdnUrl: {
        type: String,
        default: ''
      }
    },

    methods: {
      removeListeners() {
        document.getElementById('toaster').removeEventListener('animationend', this.handleTransitionEnd, false)
        document.getElementById('toaster').removeEventListener('webkitAnimationEnd', this.handleTransitionEnd, false)
      },

      handleTransitionEnd() {
        console.log('animation ends')
        this.$emit('hide')

        this.removeListeners()
      }
    },

    mounted() {
      document.getElementById('toaster').addEventListener('animationend', this.handleTransitionEnd, false)
      document.getElementById('toaster').addEventListener('webkitAnimationEnd', this.handleTransitionEnd, false)
    }
  }
</script>

<style lang="scss" src="./index.scss" />